import { render, staticRenderFns } from "./foreign-address-list.vue?vue&type=template&id=ba85faa8&scoped=true"
import script from "./foreign-address-list.vue?vue&type=script&lang=js"
export * from "./foreign-address-list.vue?vue&type=script&lang=js"
import style0 from "./foreign-address-list.vue?vue&type=style&index=0&id=ba85faa8&prod&scoped=true&lang=less"
import style1 from "@/assets/h5css/user/address-list.less?vue&type=style&index=1&id=ba85faa8&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba85faa8",
  null
  
)

export default component.exports